


























































































































































































































































































































import {
    State,
    Action,
    Getter,
    Mutation
} from "vuex-class";
import {
    Component,
    Vue,
    Prop,
    Watch
} from "vue-property-decorator";
import {
    componentDataType
} from "../types";
import {
    API_URL
} from "../global";
import axios from "axios";
import {
    ValidationObserver,
    ValidationProvider
} from "vee-validate";

const DEFAULT_DEALER_FORM = {
    full_name: "",
    email: "",
    phone: "",
    company_name: "",
    company_city: "",
    company_country: "",
    city_zip_code: "",
    company_website: "",
    street_address: "",
    state: "",
    dealer_type: null,
};

@Component({
    name: "Dform",
    components: {
        ValidationObserver,
        ValidationProvider
    }
})
export default class Dform extends Vue {
    @Prop() public compData!: string | null;
    public dealerform: any = JSON.parse(JSON.stringify(DEFAULT_DEALER_FORM));
    submitted: boolean = false;
    submitSuccess: boolean = false;

    resetForm() {
        this.dealerform = JSON.parse(JSON.stringify(DEFAULT_DEALER_FORM));
    }
    submitForm() {
        //   this.$validator.validate().then(valid => {
        //             if (valid) {
        axios
            .post(`${API_URL}/dealer/`, this.dealerform)
            .then((resp: any) => {
                this.submitted = true;
                this.submitSuccess = true;
            })
            .catch((err: any) => {
                this.submitted = true;
            });
        //     }
        // });
    }

    isActive: boolean = false;
    value: number | null = null;

    public data() {
        return {
            activetab: "1",
            dealer_type: '',
            items: {
                1: {
                    id: 'apex-franchisee',
                    val: 'Apex Franchisee'
                },
                2: {
                    id: 'fly-franchisee',
                    val: 'Fly Franchisee'
                },
                3: {
                    id: 'wholesale',
                    val: 'Wholesale'
                },
            }
        };
    }

}
